<template>
  <a-card :bordered="false" v-if='checkResult'>
    <div id='pdfCentent'>
      <div style="text-align: center;font-weight: bold;font-size: 30px">下浮率及相关系数抽取记录</div>
      <div style="margin: 20px 0 0 80px" v-show="!pdfCententShow" v-if="xstatus.isFloatRateFinish !== '1'">
        <div style="margin-left:25px" >
          <span class="text" >是否需要抽取下浮率：</span>
          <a-radio-group v-model="isEval" :disabled="exitDeclineRate">
            <a-radio :value=1>
              是
            </a-radio>
            <a-radio :value=0>
              否
            </a-radio>
          </a-radio-group>
        </div>
        <div v-show="isEval == 1">
          <span class="text">请输入下浮率抽取结果：</span>
          <a-input v-model="declineRate" :readOnly="exitDeclineRate" style="width: 150px"/>
        </div>
        <div style="margin-left:200px;margin-top: 10px" >
          <span class="text" style="float: left">备注：</span>
          <a-textarea v-model="declineRateRemark" :readOnly="exitDeclineRate" style="width: 1000px;height: 130px;"   :max-length='1000'/>
        </div>
        <a-upload name="file"
                  :showUploadList="false"
                  :headers="tokenHeader"
                  :data="annex"
                  :action="uploadAction"
                  accept=".pdf"
                  @change="handleChange"
                  :beforeUpload="beforeUpload"
                  multiple>
          <a-button type="primary" :loading="uploadLoading" style="margin: 5px" :disabled="exitDeclineRate" class="noPrint">上传附件</a-button>
        </a-upload>
      </div>

      <div style="margin-top: 10px">
        <span v-for="(item,i) in annexFile" v-show="annexFile.length>0">
          <span style="margin: 5px;" >附件:{{item.fileName}}
          <a @click="handleDownload(item.id)" class="noPrint">[下载]</a>
          <a @click="fileDelete(item.id)" class="noPrint" v-show="!exitDeclineRate">[删除]</a>
          </span>
       </span>
      </div>
    </div>
    <SignFileShow v-if="xstatus.isFloatRateFinish === '1' && !pdfCententShow" :sectionId='sectionId' :type='pdfParams.type'></SignFileShow>
    <div style='margin:150px 0 0 35%;display: inline-block' v-if="xstatus.isFloatRateFinish !== '1' && !pdfCententShow ">
      <a-space>
        <a-button type="primary" @click="submit" :disabled="exitDeclineRate">提交</a-button>
        <SignatureButton
          v-show="!pdfCententShow"
          ref="SignatureButton"
          :pdf-params="pdfParams"
          :stampShowed="pdfCententShow"
          :disabled="xstatus.isFloatRateFinish === '1'"
          @sign="sign"
          @signShow="signShow"
        ></SignatureButton>
      </a-space>
    </div>
    <SignatureComponent
      v-show="pdfCententShow"
      ref="stamp"
      :pdf-params="pdfParams"
      @checkStampForm="checkStampForm"
      @changeIsStamp="changeIsStamp"
    >
      <template  v-slot:header>
        <slot>
          <a-button htmlType='button'
                    @click='saveSignFile' type='primary' style="margin-right: 20px;margin-left: -10px">保存签章文件
          </a-button>
        </slot>
      </template>
    </SignatureComponent>
    <SignFileShow-modal ref='modalForm'></SignFileShow-modal>
  </a-card>
</template>

<script>
import {StatusMixin} from "@/mixins/StatusMixin";
import SignFileShowModal from '@views/bobidopen/modules/SignFileShowModal'
import SignFileShow from '@views/bobidopen/modules/SignFileShow'
import SignatureComponent from '@/components/SignatureComponent'
import SignatureButton from '@/components/SignatureButton'
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";
import {getAction, postAction, putAction} from "@api/manage";

export default {
  name: "UnfixedNationDeclineRateExtract",
  mixins: [StatusMixin],
  components:{
    SignFileShowModal,
    SignFileShow,
    SignatureButton,
    SignatureComponent
  },
  data(){
    return{
      sectionId:"",
      //以下签章-----------
      isNeedStamp: true,
      isStamp: true,
      pdfCententShow: false,
      htmlParams: {
        bidProjectId: '',
        sectionId: '',
        type: 'DeclineRateExtract',
        typeZh: '下浮率抽取',
        htmlTitle: '下浮率抽取',
        fp: '2',
      },
      pdfParams: {
        pageId: '',
        signedPdfUrl: '',
        bidProjectId: '',
        sectionId: '',
        type: 'DeclineRateExtractStamp',
        typeZh: '下浮率抽取签章',
        htmlTitle: '下浮率抽取签章',
        fp: '4',
        // zoom:'0.8', //缩放倍数
        // isLandscape: 1, //横向
        // borderDeep:'1px solid #000000',//表格边框样式参数
        signType:'1',//1:统一CA，2：工改签章
        isInputExpand:'1',//输入框内容显示不全用此属性
      },
      annex:{
        type: 'DeclineRateExtractAnnex',
        typeZh: '下浮率抽取附件',
        fp:2,
      },
      annexFile:{},
      tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
      uploadLoading:false,
      url: {
        minioUpload: "/ebid-ce/file//upload",
        minioDownload: "/ebid-ce/file/minioDownload",
        delete: "/ebid-ce/file/delete",
      },
      isEval: 1,
      declineRate:"",
      exitDeclineRate:false,
      declineRateRemark:"",
    }
  },
  props: ['checkId'],
  computed: {
    uploadAction() {
      return window._CONFIG['domianURL']+ this.url.minioUpload;
    },
  },
  watch:{
  },
  methods:{
    setBidProjectId(tenderId ,sectionId) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.sectionId = sectionId;
      this.bidProjectId = tenderId
      this.pdfParams.bidProjectId = tenderId
      this.pdfParams.sectionId = sectionId
      this.htmlParams.bidProjectId = tenderId
      this.htmlParams.sectionId = sectionId
      this.annex.bidId = tenderId
      this.annex.sectionId = sectionId
      this.pdfParams.pageId = this.sectionId + '_DeclineRateExtractAnnex_' + new Date().getTime()
      this.queryStatus()
      this.getAnnexFile()
      this.getDeclineRateInfo()
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.$message.success(`${info.file.name} 上传成功!`);
          this.getAnnexFile()
        } else {
          this.$message.error(`${info.file.response.message}`);
          this.uploadLoading = false
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.response.message}`);
        this.uploadLoading = false
      }
    },
    beforeUpload(file){
      var fileName = file.name;
      var fileType = fileName.substring(fileName.lastIndexOf('.')+1).toLowerCase();
      let allFileType =[]
      allFileType.push("pdf")
      if (!allFileType.includes(fileType)){
        this.$message.error("请上传pdf类型的文件")
        return false
      }
      //限制文件大小
      const isLt = file.size / 1024 / 1024 < 500;
      if (!isLt) {
        this.$message.error('上传的图片文件大小不能超过'+500+'MB');
        return false;
      }

      this.uploadLoading = true
      return true;
    },
    submit(){
      if(this.isEval == 1 && this.declineRate == ""){
        this.$message.error("请输入下浮率抽取结果")
        return
      }
      let that = this;
      let params = {}
      params.sectionId = this.sectionId
      params.isExtractDeclineRate = this.isEval
      params.floatRate = this.declineRate
      params.declineRateRemark = this.declineRateRemark
      that.$confirm({
        title: '提示',
        content: '提交后无法修改，确定提交结果吗',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          postAction("/ebid-ce/unfixed/updateDeclineRateBySectionId",params).then(res=>{
            if (res.success) {
              that.$message.success(res.result)
              that.exitDeclineRate = true
            }
          })
        },
        onCancel() {
        },
      });
    },
    //-----------以下为签章--------------------
    sign(type) {
      if (!this.exitDeclineRate){
        this.$message.warning("请先提交")
        return
      }
      this.pdfParams.signType = type;
      this.pdfCententShow = true
      this.$refs.stamp.checkStamp()
    },
    //签章文件查看
    signShow() {
      this.$refs.modalForm.show(this.sectionId, this.pdfParams.type)
    },
    changeIsStamp(val) {
      this.pdfCententShow = val
    },
    checkStampForm(callback) {
      callback(true)
    },
    saveSignFile(){
      if (this.$refs.stamp.getPdfUrl() == null) {
        this.$message.info('请先签章')
        return
      }
      let that = this;
      let params = {}
      params.pdfUrl = that.$refs.stamp.getPdfUrl()
      params.type = that.pdfParams.type
      params.typeZh = that.pdfParams.typeZh
      params.bidProjectId = that.bidProjectId
      postAction("/ebid-ce/boOpenStatus/saveFloatRateFinishSignFile/" + that.sectionId, params).then(res=> {
        if (res.success) {
          that.$message.success(res.result)
          that.xstatus.isFloatRateFinish = '1'
          that.pdfCententShow = false
        }else {
          that.$message.error(res.message)
        }
      }).catch(error => {
        that.$message.error(error)
      })
    },
    getAnnexFile(){
      let params = []
      params.bidId = this.bidProjectId
      params.type = "DeclineRateExtractAnnex"
      getAction("/ebid-ce/file/list",params).then(res =>{
        if (res.success){
          this.annexFile =res.result.records
          this.uploadLoading = false
        }
      })
    },
    handleDownload(annexId){
      let that = this;
      getAction(that.url.minioDownload,{id: annexId}).then(res => {
        if(res.success) {
          window.open(res.result,'_blank');
        }else{
          that.$message.error(res.message);
        }
      });
    },
    fileDelete(annexId){
      var that = this;
      putAction(that.url.delete, {id: annexId}).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.getAnnexFile()
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    getDeclineRateInfo(){
      getAction("/ebid-ce/waterTransportBenchmarkPriceCompute/getKstandPriceBySectionId",{sectionId:this.sectionId}).then(res=> {
        if (res.success){
          if (res.result.isExtractDeclineRate != null){
            this.exitDeclineRate = true
            this.isEval = parseInt(res.result.isExtractDeclineRate)
            this.declineRate = res.result.floatRate
            this.declineRateRemark = res.result.declineRateRemark
          }else{
            this.exitDeclineRate = false
          }
        }
      })
    },
  }
}
</script>

<style scoped>
  .text{
    font-size: 25px;
    font-weight: bold;
  }
  @media print {
    .noPrint{
      display: none;
    }
  }
</style>